import { render, staticRenderFns } from "./DocumentsManagerAll.vue?vue&type=template&id=333806a3"
import script from "./DocumentsManagerAll.vue?vue&type=script&lang=ts"
export * from "./DocumentsManagerAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333806a3')) {
      api.createRecord('333806a3', component.options)
    } else {
      api.reload('333806a3', component.options)
    }
    module.hot.accept("./DocumentsManagerAll.vue?vue&type=template&id=333806a3", function () {
      api.rerender('333806a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/manager/DocumentsManagerAll.vue"
export default component.exports